import React from 'react'
import LazyLoad from 'react-lazyload'
import { useMediaQuery } from '@helpers/hooks'
import ProductCard from '@components/ui/ProductCard'
import ProductCardHeader from '@components/ui/ProductCard/ProductCardHeader'
import ProductCardProperties, {
  ProductCardPropertiesProps
} from '@components/ui/ProductCard/ProductCardProperties'
import { resizeShopifyImage } from '@helpers/shopify'
import { BREAKPOINT_SIZES } from '@consts/index'
import styles from './styles.module.scss'

export type ModalProductCardProps = {
  image: string
  productType: string
  productProperties: ProductCardPropertiesProps['properties']
  newProductPropertiesToCompare?: ProductCardPropertiesProps['newPropertiesToCompare']
  classes?: string
}

function ModalProductCard({
  image,
  productType,
  productProperties,
  newProductPropertiesToCompare,
  classes = ''
}: ModalProductCardProps) {
  const isSmallScreenView = useMediaQuery({
    maxWidth: BREAKPOINT_SIZES.TABLET_LARGE - 1
  })

  const imageSrc =
    !image || image === ''
      ? 'https://cdn.shopify.com/s/files/1/0076/2131/2569/files/NoProductImageAvailable.jpg'
      : resizeShopifyImage(image, {
          width: '832',
          height: '1082',
          crop: 'center'
        })

  if (isSmallScreenView) {
    return (
      <div className={styles.modalProductCard__cardDetailsWrapper}>
        <ProductCard
          image={image}
          title={productType}
          properties={productProperties}
          newPropertiesToCompare={newProductPropertiesToCompare}
          classes={`${styles.modalProductCard__cardDetails__fullWidth} ${classes}`}
        />
      </div>
    )
  }

  return (
    <div className={`${styles.modalProductCard} ${classes}`}>
      <div className={styles.modalProductCard__image}>
        <LazyLoad>
          <img src={imageSrc} alt={productType} />
        </LazyLoad>
      </div>
      <div className={styles.modalProductCard__product__detailsDesktop}>
        <ProductCardHeader
          title={productType}
          classes={styles.modalProductCard__productCardHeader__centerAlign}
        />
        <ProductCardProperties
          properties={productProperties}
          newPropertiesToCompare={newProductPropertiesToCompare}
        />
      </div>
    </div>
  )
}

export default ModalProductCard
